import React from "react";
import { useTranslation } from "react-i18next";

/** First tab stop; visually hidden until focused; jumps to <main id="main"> (spec c.7 §0). */
const SkipLink: React.FC = () => {
  const { t } = useTranslation();
  return (
    <a className="skip-link" href="#main">
      {t("header.skipToContent")}
    </a>
  );
};

export default SkipLink;
